import { create } from "zustand";

const useAvatarStore = create((set) => ({
  selectedAvatar: null, // 'alex' | 'olivia'
  avatarEmotion: "waiting", // 'greeting' | 'explaining' | 'success' | 'objection' | 'confusion' | 'waiting'
  coachState: "idle", // 'idle' | 'listening' | 'thinking' | 'speaking'
  chatOpen: false,
  speaking: false,
  listening: false,
  thinking: false,
  sessionActive: false,
  waveformPoints: [],

  // Actions
  setSelectedAvatar: (avatar) => set({ selectedAvatar: avatar }),
  setAvatarEmotion: (emotion) => set({ avatarEmotion: emotion }),
  setCoachState: (state) => set({ coachState: state }),
  setChatOpen: (open) => set({ chatOpen: open }),
  setSpeaking: (speaking) => set({ speaking }),
  setListening: (listening) => set({ listening }),
  setThinking: (thinking) => set({ thinking }),
  setSessionActive: (active) => set({ sessionActive: active }),
  setWaveformPoints: (points) => set({ waveformPoints: points }),

  resetStore: () =>
    set({
      selectedAvatar: null,
      avatarEmotion: "waiting",
      coachState: "idle",
      chatOpen: false,
      speaking: false,
      listening: false,
      thinking: false,
      sessionActive: false,
      waveformPoints: [],
    }),
}));

export default useAvatarStore;
